//Respondent container details
import React, { Component } from 'react';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import DropDownTable from '../../Shared/DropDownTable';
import StarRatingModal from "../../Shared/StarRatingModal";
import '../../../css/MarketPlace/RespondentTSContainerDetails.css';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import arrowup from '../../../Assets/ProfileManagement/Assets-Desktop/arrow-up.svg';
import arrowdown from '../../../Assets/ProfileManagement/Assets-Desktop/arrow-down.svg';
import search from '../../../Assets/TruckVisits/Assets-Desktop/search-icon.svg';
import ContainerDetailesData from '../../../Data/MarketPlace/RespondentTSContainerDetails.json';
import SuccessModal from '../../Shared/SuccessModal';
import Message from '../../../Data/Shared/Message.json';
import ColorCode from '../../../Data/Shared/ColorCode.json';
import edit from '../../../Assets/ProfileManagement/Assets-Desktop/edit.svg';
import bigBlankStar from '../../../Assets/NominateRequest/starBlank_large.svg';
import Input from '../../Shared/Input';
import bigFilledStar from '../../../Assets/NominateRequest/starFilled_large.svg';
import drawer from '../../../Assets/ProfileManagement/Assets-Desktop/arrow-up.svg';
import downarrow from '../../../Assets/ProfileManagement/Assets-Desktop/arrow-down.svg';
import GenericReusableModal from '../../Shared/GenericReusableModal';
import defautRadioButton from '../../../Assets/ProfileManagement/Assets-Desktop/defautRadioButton.svg'
import selectedRadioButton from '../../../Assets/TerminalHandling/radio-checked.svg';
import {
    ContainerSourceAlphaAscendingSorting, ContainerSourceAlphaDescendingSorting,
    ContainerDestinationAlphaAscendingSorting, ContainerDestinationAlphaDescendingSorting,
    ContainerStatusAlphaAscendingSorting, ContainerStatusAlphaDescendingSorting
} from '../../../Services/utils/AlphaSorting';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { serviceBaseURL, utilityBaseURL } from '../../../Services/config/apiGateway';
import { SERVICE_RESPONDENT_CONTAINER_ENDPOINT, SERVICE_CANCELLATION_POLICY_ENDPOINT, SERVICE_REQUEST_ENDPOINT } from '../../../Services/config/apiEndPoints';
class RespondentTSContainerDetails extends Component {
    constructor(props) {
        super(props)
        this.container = React.createRef();
        this.state = {
            hasOpen: false,
            StarRated: '',
            StarRating: '',
            QuotationSubmitFlag: true,
            hasOpenSuccess: false,
            hasOpenRating: false,
            hasOpenUpdateModal: false,
            ratingStar: '',
            errorStarReason: "",
            reasonTextLimit: 0,
            truckDropdown: [],
            editIndex: '',
            truckValue: [],
            DriverDropdown: [],
            DrivereditIndex: '',
            driverValue: [],
            DropOffLocation: 'Terminal',
            Terminal: '',
            Terminaldropdown: false,
            Terminaldata: [],
            Address: '',
            ContainerNumberValue: '',
            ContainerNumberdropdown: false,
            ContainerNumberdata: [{ name: "dca" }, { name: "abc" }, { name: "bcd" }],
            searchContainerNumberlength: 0,
            ContainerNumberSearcheddata: [],
            cData: [],
            errors: {},
            containerTableData: [],
            EditedContainerData: [],
            detailsData: []
        }
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.handlechangesearchContainerNumberID = this.handlechangesearchContainerNumberID.bind(this);
    }
    TruckDropdownData = [{ name: "ND13518" }, { name: "KBB228MP" }, { name: "ND613690" }
        , { name: "KDY307MP" }, { name: "ND580458" }, { name: "ND839736" }, { name: "ND13518" }, { name: "KBB228MP" }]
    DriverDropdownData = [{ name: "John Doe" }, { name: "Michel Johnson" }, { name: "Rick Carlos" }
        , { name: "Battly Van" }, { name: "Buddy Goldman" }, { name: "Michel Johnson" }, { name: "John Doe" }, { name: "John Jonson" }]
    Terminaldata = [{ name: "Cape Town Container Terminal" }, { name: "Cape Town Container" }, { name: "Terminal" }]
    componentDidMount = () => {
        document.addEventListener("mousedown", this.handleClickOutside);
        this.getContainerDetails();
    }
    handleClickOutside = event => {
        if (this.container.current && !this.container.current.contains(event.target)) {
            let a = this.state.truckDropdown;
            a[this.state.editIndex] = false;
            this.setState({ truckDropdown: a });
            let b = this.state.DriverDropdown;
            b[this.state.DrivereditIndex] = false;
            this.setState({ DriverDropdown: b });
            this.setState({ Terminaldropdown: false });
            this.setState({ ContainerNumberdropdown: false });
        }
    };
    getContainerDetails = (serviceId) => {
        ApiCall(
            'GET',
            serviceBaseURL + SERVICE_CANCELLATION_POLICY_ENDPOINT,
            //  serviceBaseURL + SERVICE_RESPONDENT_CONTAINER_ENDPOINT + `?serviceRequestId=${serviceId}`,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        ).then((apiData) => {
            apiData =
                [
                    {
                        "containerNumber": 12324343,
                        "source": "Durban Port",
                        "destination": "Richards Bay",
                        "driversList": [
                            {
                                "driverName": "John Doe",
                                "driverLicenseNumber": 123213213,
                                "isTerminalBound": "Yes"
                            }
                        ],
                        "trucksList": [
                            {
                                "truckRegnNbr": "sa-d-21-5678",
                                "truckType": "8feet"
                            }
                        ],
                        "startTime": "15/02/2021 05:21:33",
                        "endTime": "15/02/2021 05:21:33",
                        "images": "/sharepoint/image1.png",
                        "status": "Completed"
                    },
                    {
                        "containerNumber": 12324343,
                        "source": "Durban Port",
                        "destination": "Richards Bay",
                        "driversList": [
                            {
                                "driverName": "",
                                "driverLicenseNumber": 123213213,
                                "isTerminalBound": "Yes"
                            }
                        ],
                        "trucksList": [
                            {
                                "truckRegnNbr": "",
                                "truckType": "8feet"
                            }
                        ],
                        "startTime": "15/02/2021 05:21:33",
                        "endTime": "15/02/2021 05:21:33",
                        "images": "",
                        "status": "Completed"
                    }
                ]
            if (apiData.flag != -1) {
                if (apiData.flag == 500) {
                    console.log('I am 500!');
                } else {
                    console.log('I am 200!', apiData);
                    this.setState({
                        containerTableData: apiData,
                        EditedContainerData: apiData,
                        detailsData: apiData
                    })
                    console.log('abc--', this.state.containerTableData)
                }
            }
        });
    }
    onSubmit = (i) => {
        this.updateContainerDetails(i)
    }
    updateContainerDetails = (i) => {
        console.log("cd", this.state.EditedContainerData[i])
        ApiCall(
            'PUT',
            serviceBaseURL + SERVICE_REQUEST_ENDPOINT,
            // serviceBaseURL + SERVICE_RESPONDENT_CONTAINER_ENDPOINT,
            {
                "serviceRequestId": 1232324,
                "containers":
                    [
                        {
                            "containerNumber": this.state.EditedContainerData[i].containerNumber,
                            "source": this.state.EditedContainerData[i].source,
                            "destination": this.state.EditedContainerData[i].destination,
                            "driversList": [
                                {
                                    "driverName": this.state.EditedContainerData[i].driversList.driverName,
                                    "driverLicenseNumber": this.state.EditedContainerData[i].driversList.driverLicenseNumber,
                                    "isTerminalBound": this.state.EditedContainerData[i].driversList.isTerminalBound
                                }
                            ],
                            "trucksList": [
                                {
                                    "truckRegnNbr": this.state.EditedContainerData[i].trucksList.truckRegnNbr,
                                    "truckType": this.state.EditedContainerData[i].trucksList.truckType
                                }
                            ],
                            "startTime": this.state.EditedContainerData[i].startTime,
                            "endTime": this.state.EditedContainerData[i].endTime,
                            "images": this.state.EditedContainerData[i].images,
                            "status": this.state.EditedContainerData[i].status
                        }
                    ]
            },
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        ).then(data => {
            if (data.flag != -1) {
                if (data.flag == '500') {
                    console.log('I am 500!');
                } else {
                    console.log('I am 200!');
                    this.props.history.push({
                        pathname: `/QuotationHistory`
                    })
                }
            }
        });
    }
    searchContainerNumber = () => {
        if (this.state.ContainerNumberValue.length > 0) {
            const datafilter = ContainerDetailesData.filter(i => i.containerNumber == this.state.ContainerNumberValue)
            this.setState({ containerTableData: datafilter });
        }
    }
    handleContinue = () => {
    }
    updateRating(index) {
        this.setState({ StarRated: index + 1 });
    }
    updateStarRating(index) {
        this.setState({ StarRating: index + 1 });
    }
    onSubmitModal = () => {
        this.setState({ hasOpen: false })
    }
    onCloseModal = () => {
        this.setState({ hasOpenSuccess: false });
    };
    updateRating = (index) => {
        this.setState({ ratingStar: index + 1 });
        this.setState({ errorStarReason: '' });
    }
    handleChangeComment = (e) => {
        if (e.target.value.length <= 50) {
            this.setState({ reasonTextLimit: e.target.value.length });
            this.setState({ reason: e.target.value });
            this.setState({
                errors: {
                    ...this.state.errors,
                    Comment: ''
                }
            });
            document.getElementsByName('Comment')[0].style.borderColor = ColorCode.colorCode.black;
        }
    }
    onSumbitRating = () => {
        if (this.handleValidationModel()) {
            document.documentElement.scrollTop = 0;
            this.setState({ hasOpenRating: false });
        }
    };
    handleValidationModel = () => {
        let errorStarReason = '';
        let errors = {};
        let formIsValid = true;
        if (this.state.hasOpenRating == true) {
            if (!this.state.ratingStar) {
                formIsValid = false;
                errorStarReason = Message.validation.rating;
            }
            if (!this.state.reason) {
                errors["Comment"] = Message.validation.required;
                document.getElementsByName('Comment')[0].style.borderColor = ColorCode.colorCode.red;
            } else {
                document.getElementsByName('Comment')[0].style.borderColor = ColorCode.colorCode.black;
            }
        }
        this.setState({ errors: errors });
        this.setState({ errorStarReason: errorStarReason })
        return formIsValid;
    }
    onUpdateDropOffLocation = () => {
        this.setState({ hasOpenUpdateModal: true });
    }
    onCloseUpdateLocationModal = () => {
        if (this.handleUpdateLocationModalValidation()) {
            this.setState({ hasOpenUpdateModal: false });
        }
    };
    toggleDropOffLocation = (val) => {
        if (val === "Terminal") {
            this.setState({ DropOffLocation: 'Terminal' })
        }
        if (val === "Address") {
            this.setState({ DropOffLocation: 'Address' })
        }
        this.setState({
            errors: {
                ...this.state.errors,
                DropOffLocation: ''
            }
        });
    }
    handleUpdateLocationModalValidation() {
        let errors = {};
        let formIsValid = true;
        if (this.state.DropOffLocation === '') {
            formIsValid = false;
            errors["DropOffLocation"] = Message.validation.required;
        }
        if (this.state.DropOffLocation === 'Terminal') {
            if (!this.state.Terminal) {
                formIsValid = false;
                errors["Terminal"] = Message.validation.required;
                document.getElementsByName('Terminal')[0].style.borderColor = ColorCode.colorCode.red;
            } else {
                document.getElementsByName('Terminal')[0].style.borderColor = ColorCode.colorCode.black;
            }
        }
        if (this.state.DropOffLocation === 'Address') {
            if (!this.state.Address) {
                formIsValid = false;
                errors["Address"] = Message.validation.required;
                document.getElementsByName('Address')[0].style.borderColor = ColorCode.colorCode.red;
            } else {
                document.getElementsByName('Address')[0].style.borderColor = ColorCode.colorCode.black;
            }
        }
        this.setState({ errors: errors });
        return formIsValid;
    }
    toggleDropdownTerminal = () => {
        this.setState({ Terminaldropdown: !this.state.Terminaldropdown });
    };
    changeRoleTypeTerminal = (event) => {
        const found = this.Terminaldata.find((name) => {
            if (name.name === event.target.innerText) {
                return name
            }
        })
        this.setState({ Terminal: found.name });
        this.setState({ Terminaldropdown: !this.state.Terminaldropdown });
        this.setState({
            errors: {
                ...this.state.errors,
                Terminal: ''
            }
        });
        document.getElementsByName('Terminal')[0].style.borderColor = ColorCode.colorCode.black;
    }
    handleChangeAddress = (e) => {
        this.setState({ Address: e.target.value });
        this.setState({
            errors: {
                ...this.state.errors,
                Address: ''
            }
        });
        document.getElementsByName('Address')[0].style.borderColor = ColorCode.colorCode.black;
    }
    handleChangeContainerNumber = (e) => {
        this.setState({ ContainerNumberValue: e.target.value, searchContainerNumberlength: e.target.value.length });
    }
    handlechangesearchContainerNumberID = (e) => {
        this.setState({
            ContainerNumberValue: e.target.value,
            searchContainerNumberlength: e.target.value.length
        });
    };
    changeContainerNumber = (event) => {
        const found = this.state.ContainerNumberSearcheddata.find((name) => {
            if (name.name === event.target.innerText) {
                return name
            }
        })
        this.setState({ ContainerNumberValue: found.name });
        this.setState({ ContainerNumberdropdown: !this.state.ContainerNumberdropdown });
    }
    onSortingSource = (e) => {
        if (e == "ascending") {
            this.setState({
                containerTableData: ContainerSourceAlphaAscendingSorting(this.state.containerTableData),
                EditedContainerData: ContainerSourceAlphaAscendingSorting(this.state.EditedContainerData)
            })
        } else if (e == "descending") {
            this.setState({
                containerTableData: ContainerSourceAlphaDescendingSorting(this.state.containerTableData),
                EditedContainerData: ContainerSourceAlphaDescendingSorting(this.state.EditedContainerData)
            })
        }
    }
    onSortingDestination = (e) => {
        if (e == "ascending") {
            this.setState({
                containerTableData: ContainerDestinationAlphaAscendingSorting(this.state.containerTableData),
                EditedContainerData: ContainerDestinationAlphaAscendingSorting(this.state.EditedContainerData)
            })
        } else if (e == "descending") {
            this.setState({
                containerTableData: ContainerDestinationAlphaDescendingSorting(this.state.containerTableData),
                EditedContainerData: ContainerDestinationAlphaDescendingSorting(this.state.EditedContainerData)
            })
        }
    }
    onSortingStatus = (e) => {
        if (e == "ascending") {
            this.setState({
                containerTableData: ContainerStatusAlphaAscendingSorting(this.state.containerTableData),
                EditedContainerData: ContainerStatusAlphaAscendingSorting(this.state.EditedContainerData)
            })
        } else if (e == "descending") {
            this.setState({
                containerTableData: ContainerStatusAlphaDescendingSorting(this.state.containerTableData),
                EditedContainerData: ContainerStatusAlphaDescendingSorting(this.state.EditedContainerData)
            })
        }
    }
    render() {
        if (this.state.searchContainerNumberlength == 0) {
            this.state.datatemporary = this.state.detailsData;
            this.state.containerTableData = this.state.detailsData;
        }
        return (
            <div class="RespondentTSCDOutercolor">
                <MetaDecorator title={TitleDescription.RespondentTSContainerDetailsTitle} description={TitleDescription.RespondentTSContainerDetailsDescription} />
                <Header tilesFetched={() => { }} />
                <div class="RespondentTSCDOuterDivcss">
                    <div id="RespondentTSCDBoxDiv">
                        <nav class="RespondentTSCDNavbar">
                            <div className="RespondentTSCDNavbarName">
                                <small id="RespondentTSCDNavbarText">Container Details</small>
                            </div>
                            <div id="RespondentTSCDRAcceptMobile" className="RespondentTSCDRNavbarNameRight">
                                <small class="RespondentTSCDRNavbarRightText" onClick={this.onUpdateDropOffLocation}>Update Drop-Off Location</small>
                            </div>
                        </nav>
                        <hr class="hr1" />
                        <nav class="RespondentTSCDRMobileNavbar">
                            <div className="RespondentTSCDRNavbarNameRight">
                                <small class="RespondentTSCDRNavbarRightText" onClick={this.onUpdateDropOffLocation}>Update Drop-Off Location</small>
                            </div>
                        </nav>
                        <hr class="hrCDMobile" />
                        <div class="RespondentTSCDMidPartition">
                            <div class="RespondentTSCDMainDiv">
                                <div class="RespondentTSCDTableDiv">
                                    <table class="RespondentTSCDTable">
                                        <thead id="RespondentTSCDTabalHeadDiv">
                                            <tr id="RespondentTSCDTableHeadRowCmnCss">
                                                <div id="RespondentTSCDHeadCol1">
                                                    <div class="RespondentTSCDCnoDiv">
                                                        <div>
                                                            <div className="pass-wrapper" id="RespondentTSCDGRmodalInpDiv" >
                                                                <Input
                                                                    class placeholder="Container No."
                                                                    type="text" id="RespondentTSCDGRmodalInpConCss" value={this.state.ContainerNumberValue}
                                                                    onChange={this.handlechangesearchContainerNumberID}
                                                                />
                                                                <div className="RespondentTSCDGRmodalDropError">{this.state.errors["ContainerNumberValue"]}</div>
                                                                <img onClick={this.searchContainerNumber} id="RespondentTSCDGRmodalSearchCon_imgcss" src={search}></img>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="RespondentTSCDHeadDiv">
                                                    </div>
                                                </div>
                                                <div id="RespondentTSCDcol2Headcss">
                                                    <div class="RespondentTSCDStatusDiv">
                                                        <div id="RespondentTSCDTabHeadcoltextCmnCss" class="RespondentTSCDHeadC1up">Source</div>
                                                        <div class="RespondentTSCDAccordianDiv">
                                                            <img class="RespondentTSCDAccordianupimg" src={arrowup} onClick={() => this.onSortingSource("ascending")} />
                                                            <img class="RespondentTSCDAccordianimg" src={arrowdown} onClick={() => this.onSortingSource("descending")} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div id="RespondentTSCDcolHeadcss" class="RespondentTSCDTablebodycol6">
                                                    <div class="RespondentTSCDStatusDiv">
                                                        <div id="RespondentTSCDTabHeadcoltextCmnCss" class="RespondentTSCDHeadC1up">Destination</div>
                                                        <div class="RespondentTSCDAccordianDiv">
                                                            <img class="RespondentTSCDAccordianupimg" src={arrowup} onClick={() => this.onSortingDestination("ascending")} />
                                                            <img class="RespondentTSCDAccordianimg" src={arrowdown} onClick={() => this.onSortingDestination("descending")} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div id="RespondentTSCDcolHeadcss" class="RespondentTSCDTablebodycol11">
                                                    <div id="RespondentTSCDTabHeadcoltextCmnCss">
                                                        Driver
                                                    </div>
                                                </div>
                                                <div id="RespondentTSCDcolHeadcss" class="RespondentTSCDTablebodycol12">
                                                    <div id="RespondentTSCDTabHeadcoltextCmnCss">
                                                        Truck
                                                    </div>
                                                </div>
                                                <div id="RespondentTSCDcolHeadcss" class="RespondentTSCDTablebodycol13">
                                                    <div id="RespondentTSCDTabHeadcoltextCmnCss">
                                                        <text class="RespondentTSCDHeadC1up">Trip Start</text>
                                                        <text class="RespondentTSCDHeadC1low">Time</text>
                                                    </div>
                                                </div>
                                                <div id="RespondentTSCDcolHeadcss" class="RespondentTSCDTablebodycol13">
                                                    <div id="RespondentTSCDTabHeadcoltextCmnCss">
                                                        <text class="RespondentTSCDHeadC1up">Trip End</text>
                                                        <text class="RespondentTSCDHeadC1low">Time</text>
                                                    </div>
                                                </div>
                                                <div id="RespondentTSCDcolHeadcss" class="RespondentTSCDTablebodycol13">
                                                    <div id="RespondentTSCDTabHeadcoltextCmnCss">
                                                        <text class="RespondentTSCDHeadC1up">Images </text>
                                                        <text class="RespondentTSCDHeadC1low">by Driver</text>
                                                    </div>
                                                </div>
                                                <div id="RespondentTSCDcolHeadcss" class="RespondentTSCDTablebodycol13">
                                                    <div class="RespondentTSCDStatusDiv">
                                                        <div id="RespondentTSCDTabHeadcoltextCmnCss" class="RespondentTSCDHeadC1up">Status</div>
                                                        <div class="RespondentTSCDAccordianDiv">
                                                            <img class="RespondentTSCDAccordianupimg" src={arrowup} onClick={() => this.onSortingStatus("ascending")} />
                                                            <img class="RespondentTSCDAccordianimg" src={arrowdown} onClick={() => this.onSortingStatus("descending")} />
                                                        </div>
                                                    </div>
                                                </div>
                                                {this.state.QuotationSubmitFlag && <td id="RespondentTSCDcolHeadcss" class="RespondentTSCDTablebodycolSubmit"></td>}
                                            </tr>
                                        </thead>
                                        <tbody class="CDTBody">
                                            {(this.state.containerTableData.map((Data, index) => {
                                                return (
                                                    <tr class="RespondentTSCDTablerow" id="RespondentTSCDTableRowCmnCss">
                                                        <div id="RespondentTSCDTablebodycol1">
                                                            <div class="RespondentTSCDTablebodycoldiv">
                                                                <div class="RespondentTSCDbodyC1left">{index + 1}</div>
                                                                <div class="RespondentTSCDbodyCright">
                                                                    <text class="RespondentTSCDbodyC1up">{Data?.containerNumber}</text>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div id="RespondentTSCDTablebodycol2">
                                                            <div id="RespondentTSCDTablecoltextCmnCss">{Data?.source}</div>
                                                        </div>
                                                        <div id="RespondentTSCDTablebodycol" class="QuotationCDetailsTablebodycol6">
                                                            <div id="RespondentTSCDTablecoltextCmnCss">{Data?.destination}</div>
                                                        </div>
                                                        <div id="RespondentTSCDTablebodycol" class="RespondentTSCDTablebodycol11">
                                                            <div id="RespondentTSCDTablecoltextCmnCss" class="RespondentTSCDTableDrivercolCss">
                                                                {(Data?.driversList[0]?.driverName === "" || Data.Submit)
                                                                    ?
                                                                    <>
                                                                        <div className="pass-wrapper" id="RespondentTSCDFillInpDiv" >
                                                                            <Input
                                                                                readOnly name="VentilationUnit" class={this.state.DriverDropdown[index] ? "RespondentTSCDFillInpRChange" : "RespondentTSCDFillBondFDcss"}
                                                                                placeholder="-- Select --"
                                                                                type="text" id="RespondentTSCDFillBondedFD"
                                                                                value={this.state.EditedContainerData[index].driversList.driverName}
                                                                            />
                                                                            <i id="RespondentTSCDFill_inpImg"
                                                                                onClick={() => {
                                                                                    let a = this.state.DriverDropdown;
                                                                                    a[index] = true;
                                                                                    this.setState({ DriverDropdown: a, DrivereditIndex: index })
                                                                                }}
                                                                            >{this.state.DriverDropdown[index] ? <img src={drawer} /> : <img src={downarrow} />}</i>
                                                                        </div>
                                                                        {this.state.DriverDropdown[index] && (
                                                                            <div class="RespondentTSCDFillDropdDiiv" >
                                                                                <div class="RespondentTSCDFillTDropDownCrd" ref={this.container} >
                                                                                    {(this.DriverDropdownData.map((name, i) => {
                                                                                        return (
                                                                                            <DropDownTable
                                                                                                onClick={() => {
                                                                                                    ContainerDetailesData[index].Driver = name.name;
                                                                                                    this.setState({
                                                                                                        ContainerDetailesData: ContainerDetailesData,
                                                                                                    });
                                                                                                    let d = this.state.EditedContainerData;
                                                                                                    d[index].driversList.driverName = name.name;
                                                                                                    this.setState({ EditedContainerData: d });
                                                                                                    let e = this.state.DriverDropdown;
                                                                                                    e[this.state.DrivereditIndex] = false
                                                                                                    this.setState({ DriverDropdown: e })
                                                                                                }}
                                                                                                id="RespondentTSCDFillTDropdowncss">
                                                                                                <small class="" id="RespondentTSCDFillTDropText" >{name.name} </small>
                                                                                            </DropDownTable>
                                                                                        );
                                                                                    }))}
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                    </>
                                                                    :
                                                                    <>
                                                                        {Data?.driversList[0]?.driverName}
                                                                    </>
                                                                }
                                                            </div>
                                                        </div>
                                                        <div id="RespondentTSCDTablebodyView" class="RespondentTSCDTablebodycol12">
                                                            <div id="RespondentTSCDTablecoltextCmnCss" class={Data?.trucksList[0]?.truckRegnNbr === "" ? "RespondentTSCDTableDrivercolCss" : "RespondentTSCDTableDrivercolCss RespondentTSCDTableTruckCss"}>
                                                                {(Data?.trucksList[0]?.truckRegnNbr === "" || Data.Submit)
                                                                    ?
                                                                    <>
                                                                        <div className="pass-wrapper" id="RespondentTSCDFillInpDiv" >
                                                                            <Input
                                                                                readOnly name="VentilationUnit" class={this.state.truckDropdown[index] ? "RespondentTSCDFillInpRChange" : "RespondentTSCDFillBondFDcss"}
                                                                                placeholder="-- Select --"
                                                                                type="text" id="RespondentTSCDFillBondedFD"
                                                                                value={this.state.EditedContainerData[index].trucksList.truckRegnNbr}
                                                                            />
                                                                            <i id="RespondentTSCDFill_inpImg"
                                                                                onClick={() => {
                                                                                    let a = this.state.truckDropdown;
                                                                                    a[index] = true;
                                                                                    this.setState({ truckDropdown: a, editIndex: index })
                                                                                }}
                                                                            >{this.state.truckDropdown[index] ? <img src={drawer} /> : <img src={downarrow} />}</i>
                                                                        </div>
                                                                        {this.state.truckDropdown[index] && (
                                                                            <div class="RespondentTSCDFillDropdDiiv" >
                                                                                <div class="RespondentTSCDFillTDropDownCrd" ref={this.container} >
                                                                                    {(this.TruckDropdownData.map((truck, j) => {
                                                                                        return (
                                                                                            <DropDownTable
                                                                                                onClick={() => {
                                                                                                    ContainerDetailesData[index].Truck = truck.name;
                                                                                                    this.setState({
                                                                                                        ContainerDetailesData: ContainerDetailesData,
                                                                                                    });
                                                                                                    let t = this.state.EditedContainerData;
                                                                                                    t[index].trucksList.truckRegnNbr = truck.name;
                                                                                                    this.setState({ EditedContainerData: t });
                                                                                                    let a = this.state.truckDropdown;
                                                                                                    a[this.state.editIndex] = false
                                                                                                    this.setState({ truckDropdown: a })
                                                                                                }}
                                                                                                id="RespondentTSCDFillTDropdowncss">
                                                                                                <small class="" id="RespondentTSCDFillTDropText" >{truck.name} </small>
                                                                                            </DropDownTable>
                                                                                        );
                                                                                    }))}
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                    </>
                                                                    :
                                                                    <>
                                                                        {Data?.trucksList[0]?.truckRegnNbr}
                                                                    </>
                                                                }
                                                            </div>
                                                        </div>
                                                        <div id="RespondentTSCDTablebodycol" class="RespondentTSCDTablebodycol13" >
                                                            <div id="RespondentTSCDTablecoltextCmnCss">
                                                                {Data?.startTime === ""
                                                                    ?
                                                                    <> <text id="RespondentTSCDNotYetU">Yet to</text><text id="RespondentTSCDNotYetL"> Pickup</text></>
                                                                    :
                                                                    Data?.startTime
                                                                }
                                                            </div>
                                                        </div>
                                                        <div id="RespondentTSCDTablebodycol" class="RespondentTSCDTablebodycol13">
                                                            <div id="RespondentTSCDTablecoltextCmnCss">
                                                                {Data?.endTime === ""
                                                                    ?
                                                                    <> <text id="RespondentTSCDNotYetU">Yet to</text><text id="RespondentTSCDNotYetL"> Deliver</text></>
                                                                    :
                                                                    Data?.endTime
                                                                }
                                                            </div>
                                                        </div>
                                                        <div id="RespondentTSCDTablebodyView" class="RespondentTSCDTablebodycol13" >
                                                            <div id="RespondentTSCDTabHeadcolviewtextCmnCss" style={{ color: Data?.images === "" && "#707070" }}>
                                                                {Data?.images === "" ? "No Images" : "View"}
                                                            </div>
                                                        </div>
                                                        <div id="RespondentTSCDTablebodycol" class="RespondentTSCDTablebodycol13">
                                                            <div id="RespondentTSCDTablecoltextCmnCss">{Data?.status}
                                                            </div>
                                                        </div>
                                                        {this.state.QuotationSubmitFlag &&
                                                            <td id="RespondentTSCDTablebodycol" class="RespondentTSCDTablebodycolSubmit">
                                                                <button class={(Data?.trucksList[0]?.truckRegnNbr === "" || Data?.driversList[0]?.driverName === "") ? "RespondentTSCDSmbBtn" : "RespondentTSCDSmbBtnDisable"}
                                                                    onClick={() => this.onSubmit(index)}
                                                                >
                                                                    Submit
                                                            </button>
                                                            </td>
                                                        }
                                                    </tr>
                                                );
                                            }))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="RespondentTSCDFooterUnfixed">
                    <Footer />
                </div>
                <div class="RespondentTSCDFooterFixed">
                    <Footer2 />
                </div>
                <GenericReusableModal
                    hasOpen={this.state.hasOpenUpdateModal}
                    onCloseModal={this.onCloseUpdateLocationModal}
                    buttonLabel={"Update"}
                    modalHeading={"Update Drop-Off Location"}
                    showImage={false}
                >
                    <div>
                        <div class="RespondentTSCDGRmodalRadioCardDiv">
                            <div class="RespondentTSCDGRmodalDataleft" id="RespondentTSCDGRmodalDataleftIdMobile">
                                <text class="RespondentTSCDGRmodalleftRadioText">{Message.marketPlace.genericReusableModalLocationQuery}</text>
                            </div>
                            <div class="RespondentTSCDGRmodalRadioCard">
                                <div class="RespondentTSCDGRmodalRadioDiv">
                                    <img src={this.state.DropOffLocation === "Terminal" ? selectedRadioButton : defautRadioButton}
                                        onClick={() => this.toggleDropOffLocation("Terminal")}
                                        id="RespondentTSCDGRmodalRadio_imgcss"
                                    />
                                    <div class="RespondentTSCDGRmodalRadioText">Terminal</div>
                                </div>
                                <div class="RespondentTSCDGRmodalRadioDiv">
                                    <img src={this.state.DropOffLocation === "Address" ? selectedRadioButton : defautRadioButton}
                                        onClick={() => this.toggleDropOffLocation("Address")}
                                        id="RespondentTSCDGRmodalRadio_imgcss"
                                    />
                                    <div class="RespondentTSCDGRmodalRadioText">Address</div>
                                </div>
                            </div>
                            <div className="RespondentTSCDGRmodalError">{this.state.errors["DropOffLocation"]}</div>
                            {this.state.DropOffLocation === 'Terminal' &&
                                <div class="RespondentTSCDGRmodalterminalInpDiv">
                                    <small id="RespondentTSCDGRmodalInpHeading">Terminal</small>
                                    <div className="pass-wrapper" id="RespondentTSCDGRmodalInpDiv" >
                                        <Input
                                            readOnly name="Terminal" class={this.state.Terminaldropdown ? "input RespondentTSCDGRmodalInpRadiuscss" : "input"} placeholder="Select Terminal"
                                            type="text" id="RespondentTSCDGRmodalInpDropCss" value={this.state.Terminal}
                                        />
                                        <div className="RespondentTSCDGRmodalDropError">{this.state.errors["Terminal"]}</div>
                                        <i id="RespondentTSCDGRmodalInp_imgDrop" onClick={this.toggleDropdownTerminal}>
                                            {this.state.Terminaldropdown ? <img src={drawer} /> : <img src={downarrow} />}
                                        </i>
                                    </div>
                                    {this.state.Terminaldropdown && (
                                        <div class="RespondentTSCDGRmodalDropDowmDiv" >
                                            <div class="RespondentTSCDGRmodalDropCard" ref={this.container} >
                                                {(this.Terminaldata.map((name, index) => {
                                                    return (
                                                        <DropDownTable onClick={(val) => this.changeRoleTypeTerminal(val)} id="RespondentTSCDGRmodalDropRowSize">
                                                            <small class="" id="RespondentTSCDGRmodalDropRowText" >{name.name} </small>
                                                        </DropDownTable>
                                                    );
                                                }))}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            }
                            {this.state.DropOffLocation === 'Address' &&
                                <div class="RespondentTSCDGRmodalterminalInpDiv">
                                    <small id="RespondentTSCDGRmodalInpHeading">Address</small>
                                    <div className="pass-wrapper" id="RespondentTSCDGRmodalInpDiv" >
                                        <Input
                                            name="Address"
                                            class="input" placeholder="Enter Address"
                                            type="text" id="RespondentTSCDGRmodalInpCss" value={this.state.Address}
                                            onChange={this.handleChangeAddress}
                                        />
                                        <div className="RespondentTSCDGRmodalDropError">{this.state.errors["Address"]}</div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </GenericReusableModal>
                <SuccessModal hasOpen={this.state.hasOpenSuccess} onCloseModal={this.onCloseModal}>
                    <div>
                        <div class="successRatingdivout">
                            <small class="successRatingdivsm">Your response has been submitted
 </small>
                            <small class="successRatingdivsm"> successfully.</small>
                        </div>
                    </div>
                </SuccessModal>
                <StarRatingModal hasOpen={this.state.hasOpenRating} onCloseModal={() => this.onSumbitRating()}>
                    <div class="TSRatingInpModalDivOut">
                        <div class="TSRatingInpModalHeadDiv">
                            <small class="TSRatingInpModalHeadsm">{Message.marketPlace.starRatingModalRateQueryRequester}</small>
                        </div>
                        <div class="TSRatingInpModalLowerSectionDiv">
                            <div class="TSRatingInpModalNameHeadingDiv">
                                <small class="TSRatingInpModalNameHeading">{Message.marketPlace.starRatingModalCompanyName}</small>
                            </div>
                            <div class="TSRatingInpModalImgDiv">
                                <div class="TSRatingInpModalImgDivin">
                                    {[1, 1, 1, 1, 1].map((item, index) => (
                                        <div class="TSRatingInpModalmodalimgposition"
                                            onClick={() => this.updateRating(index)}
                                            key={index}
                                        >
                                            <img src={index < this.state.ratingStar ? bigFilledStar : bigBlankStar} class="TSRatingInpModalImgStar" height="26" width="26" alt="" loading="lazy" />
                                        </div>
                                    ))}
                                </div>
                                <div className="TSRatingInpModalstarunfillerror">{this.state.errorStarReason}</div>
                            </div>
                        </div>
                        <div class="rejectMainDiv" id="TSRatingRejectMainDiv">
                            <div className="pass-wrapper" id="rejectInputDiv" >
                                <Input
                                    name="Comment"
                                    class="input" placeholder="Please enter your comment"
                                    type="text" id="CrtTptReqestInpCss" value={this.state.reason}
                                    onChange={this.handleChangeComment}
                                />
                                <i id="rejectInputIcon">
                                    <img src={edit} />
                                </i>
                                <div className="QuotationDetailsDropError">{this.state.errors["Comment"]}</div>
                                <small class="inpsmallraise">{this.state.reasonTextLimit}/50</small>
                            </div>
                        </div>
                    </div>
                </StarRatingModal>
            </div >
        );
    }
}
export default RespondentTSContainerDetails;